import { combineReducers } from '@reduxjs/toolkit'
import { authReducer } from './auth'
import tempReducer from './tempSlice'
const rootReducer = combineReducers({
  auth: authReducer,
  temp: tempReducer
})

export default rootReducer
